import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux"
import * as _ from 'lodash';
import { ClubbedApis } from "./ClubbedApis";
import { Loader, Divider } from 'cdk-radial';
import ConsentDialog from "../../../../../common/ConsentDialog";
import { consentConstant } from "../../../../../../constants/consentConstant";
import Overlay from "../../../../../Overlay/Overlay";
import {clearState, consentApiTerms, resetErrors} from "../../../../../../redux/connectedComponent/apiTerms/apiTerms.slice"
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { addConsentDetailsonTermsReview } from "../../../../../../redux/connectedComponent/selectedLocations/selectedLocations.slice";
import { sendAmplitudeData } from '../../../../../../utils/amplitude';
import { AMPLITUDE_EVENTS,AMPLITUDE_PROPERTIES } from '../../../../../../constants/amplitudeConstants';
import Notification from "../../../../../notification/Notification";

const nest = (data, keys) =>{
    if (!keys.length) {
      return data;
    }
    const first = keys[0];
    const rest = keys.slice(1);
    return _.mapValues(_.groupBy(data, first), (value) => nest(value, rest));
}

const createChunkArray = (array)=>{
    const chunkSize = 100;
    const items=[];
    for (let i = 0; i < array.length; i += chunkSize)
        items.push(array.slice(i, i + chunkSize));

    return items;
};

const LOADER_STYLE = {
  stroke: '#006CFA',
  margin: '0px 70px',
  display: 'flex'
};
const CONNECTION = 'connection';

const Addendum = (props) => {

    const dispatch = useDispatch();

    const {selectedPlanId} = useParams();

    const [customConsentApis, setCustomConsentApis] = useState([]);
    const [addendumApis, setAddendumApis] = useState([]);
    const [addendumsAccepted,setAddendumsAccepted] = useState([]);
    const [noAddendumApis,setNoAddendumApis] = useState([]);
    const [apisRequiredConsent, setApisRequiredConsent] = useState(0);
    const [consentDetails, setConsentDetails] = useState()
    const [loadingStatus, setLoadingStatus] = useState(true);
    const [openConsentDialog, setopenConsentDialog] = useState();
    const [isCustomConesentApi, setIsCustomConsentApi] = useState();
    const [selectedConnectionDetail, setselectedConnectionDetail] = useState();
    const [dialogLoader, setDialogLoder] = useState();
    const [reviewApis, setReviewApis] = useState([]);
    const [showToast, setShowToast] = useState(false);

    const {
        solutionInfoSlice,
        loginDetailsSlice,
        selectLocationsSlice,
        apiTermsSlice,
        selectDMSSlice
    } = useSelector(state => state);
    const solutionInfo = solutionInfoSlice.solutionInfo || {};
    const customConsentFormSignedS3Url = solutionInfoSlice.customConsentFormSignedS3Url;
    const userInfo = loginDetailsSlice;
    const token = loginDetailsSlice.authenticationToken;
    const selectedLocationsWithCMFNumber = selectLocationsSlice.selectedLocationsWithCMFNumber;
    const apiAndProviderRequiredForTheApp = solutionInfoSlice.apiAndProviderRequiredForTheApp;
    const isCheckAddendumsSignedPending = selectLocationsSlice.isCheckAddendumsSignedPending;
    const consentInfo = selectLocationsSlice.consentInfo;
    const addendumConsentDetails = selectLocationsSlice.addendumConsentDetails;
    const role = loginDetailsSlice.role;
    const isApiProvidersPending = solutionInfoSlice.isApiProvidersPending;
    const isApiProviderSelectedByAppPublisherPending = solutionInfoSlice.isApiProviderSelectedByAppPublisherPending;
    const consentAndConnectionRecords = apiTermsSlice.consentAndConnectionRecords;
    const getDMSInfoBasedOnApisPending = selectDMSSlice.getDMSInfoBasedOnApisPending;
    const isCheckDataRightsSignedPending = selectLocationsSlice.isCheckDataRightsSignedPending;
    const doesAppRequireDataRights = solutionInfoSlice.captureDataRights;
    const DMSConfigInfo = selectDMSSlice.DMSConfigInfo;
    const isEISDMSInfoLoading = selectDMSSlice.isEISDMSInfoLoading;
    const isDataRightsAccepted = selectLocationsSlice.isDataRightsAccepted;
    const activateOnly = solutionInfoSlice.solutionInfo.activateOnly;
    const isCreateApiTermsConsentErrored = apiTermsSlice.isCreateApiTermsConsentErrored;

    useEffect(() => {
        dispatch(resetErrors());
    }, []);

    useEffect(()=>{
      const count = apiAndProviderRequiredForTheApp && apiAndProviderRequiredForTheApp.length;
      setApisRequiredConsent(count)
    },[apiAndProviderRequiredForTheApp]);

    useEffect(()=>{
        if(!dialogLoader && consentAndConnectionRecords){
            const {consentItems, dealerPortalRecords} = consentAndConnectionRecords;
            const groupByEntityIds = _.groupBy(dealerPortalRecords, 'entityId')
            const addendumDetailsByEntityId = Object.values(groupByEntityIds).map(group => {
                const consentDetails = group.map(record => {
                    const consent = consentItems.find(consent => consent.consentId === record.consentId);
                    return {
                        documentLink: consent.customConsentForm ? consent.customConsentForm : consent.documentLink,
                        createdDate: consent.createdDate,
                        name: consent.name,
                        apiProviderId: consent.apiProviderId
                    }
                })
                return {
                    consentDetails,
                    entityId: group[0].entityId,
                    location: selectedLocationsWithCMFNumber.find(loc => loc.entityId === group[0].entityId).location
                }
            });
            dispatch(addConsentDetailsonTermsReview(addendumDetailsByEntityId));
            dispatch(clearState());
        }
    },[dialogLoader, consentAndConnectionRecords]);


    useEffect(() => {
        Object.values(consentInfo).some(obj => {
            if(!obj.addendumsAccepted){
                setLoadingStatus(true);
            } else {
                setLoadingStatus(false)
            }
        })
        const custom_consent = solutionInfo.custom_consent;

        const addendumApi = [];
        const noAddendumApi = [];
        const customConsentApi = [];
        if(customConsentFormSignedS3Url){
            // apiAndProviderRequiredForTheApp is constructed from apiAndProviders and asyncAPIs in solutionInfoSlice
            apiAndProviderRequiredForTheApp && apiAndProviderRequiredForTheApp.forEach(apiProvider => {
                if(apiProvider && (custom_consent.customConsentForm && custom_consent.selectedApis.includes(apiProvider.id.replace('api-v2-','')))){
                customConsentApi.push(apiProvider)
                }
                else{
                if(apiProvider.addendumDoc) {
                    addendumApi.push(apiProvider);
                }
                else {
                    noAddendumApi.push(apiProvider);
                }
                }
            })
        } else{
            apiAndProviderRequiredForTheApp && apiAndProviderRequiredForTheApp.map(apiProvider => {
                if(apiProvider.addendumDoc) {
                addendumApi.push(apiProvider);
                }
                else {
                noAddendumApi.push(apiProvider);
                }
            })
        }

        setCustomConsentApis(customConsentApi);
        setAddendumApis(addendumApi);
        setNoAddendumApis(noAddendumApi);

        if(!loadingStatus){
            let acceptedApis = []
            apiAndProviderRequiredForTheApp &&
                apiAndProviderRequiredForTheApp.forEach(apiProvider => {
                  apiProvider && acceptedApis.push(apiProvider.id);
                });
            let checkReturn = false;
            for (var key in consentInfo) {
                if (
                  key &&
                  consentInfo[key].addendumsAccepted &&
                  consentInfo[key].addendumsAccepted.length === 0
                ) {
                    setAddendumsAccepted([]);
                    checkReturn = true
                    return
                } else if (
                  consentInfo[key].addendumsAccepted &&
                  consentInfo[key].addendumsAccepted.length !== 0
                ) {
                  // eslint-disable-next-line no-loop-func
                    acceptedApis =  acceptedApis.filter(id => {
                        let flag = false
                        consentInfo[key].addendumsAccepted.forEach(api=>{
                        if(id === api.apiProviderId){
                            flag = true;
                        }
                        });
                        return flag
                    });
                }
            }
            setAddendumsAccepted(acceptedApis);
            if(!checkReturn){
                setAddendumsAccepted(acceptedApis);
                checkReturn = false
            }
        }
    },[consentInfo,loadingStatus, solutionInfo, apiAndProviderRequiredForTheApp, isCheckAddendumsSignedPending]);

    useEffect(()=>{
        let consentDetail = nest(addendumConsentDetails,['apiProviderId']);
        setConsentDetails(consentDetail);
    },[addendumConsentDetails]);

    useEffect(() => {
        let requiredApis = apiAndProviderRequiredForTheApp && apiAndProviderRequiredForTheApp.map(api => api.id);
        let enableNextButton = !!requiredApis.length;
        for (var key in consentInfo) {
            if (key && consentInfo[key]) {
            const {
                dataRightsAccepted,
                appTermsAccepted,
                addendumsAccepted
            } = consentInfo[key];
            let acceptedApis = addendumsAccepted && addendumsAccepted.map(addendum => addendum.apiProviderId)
            let apiNotAccepted = false
            requiredApis && requiredApis.every((api) =>{
                if( !acceptedApis || !acceptedApis.includes(api)){
                apiNotAccepted = true
                return false
                }
                return true
            })
            if (
                (doesAppRequireDataRights &&
                dataRightsAccepted !== 'Yes') ||
                (activateOnly === false && (!appTermsAccepted ||
                appTermsAccepted === false)) ||
                !addendumsAccepted || apiNotAccepted
            ) {
                enableNextButton = false ;
                break;
            }
            }
        }
        if (
            isApiProviderSelectedByAppPublisherPending ||
            isApiProvidersPending ||
            getDMSInfoBasedOnApisPending  || isCheckDataRightsSignedPending
            || (DMSConfigInfo && DMSConfigInfo.length && isEISDMSInfoLoading)
        ) {
            props.disableNextButton(true);
        } else {
            if (enableNextButton) {
                props.disableNextButton(false);
            } else {
                props.disableNextButton(true);
            }
        }
    },[apiAndProviderRequiredForTheApp, consentInfo, DMSConfigInfo, getDMSInfoBasedOnApisPending, isEISDMSInfoLoading]);

    const onReviewTerms = (
        apis,
        isAddendumsAccepted,
        isCustomConesentApi,
        isNoAddendum,
    ) => {
        setReviewApis(apis)
        setselectedConnectionDetail(apis[0]);

        if(isCustomConesentApi) {
            setIsCustomConsentApi(true)
        } else {
            setIsCustomConsentApi(false)
        }
        if(isNoAddendum){
            return saveApiConsent(apis)
        }
        if(!isAddendumsAccepted){
            setopenConsentDialog(true);
        }
    }

    const saveApiConsent = async (apis, consentData) => {
        setopenConsentDialog(false);
        setDialogLoder(true)
        const apisToReview = reviewApis.length ? reviewApis : apis;
        let {
            id: solutionId,
            overview: { version = '1' } = {},
            listingVersion = '1',
            custom_consent
        } = solutionInfo;
        let {
        decodedToken: { firstName = '', lastName = '' },
        userEmail = ''
        } = userInfo;

        const planId = props.navigatedFromSubscriptionManagement ? props.selectedPlanId : selectedPlanId;

        let api = [];
        let entityList =[];

        apisToReview && apisToReview.map(apiProvider => {
            let registrationDetailsFromSolutionInfo = solutionInfo && solutionInfo.registration_details &&
                solutionInfo.registration_details.api_details &&
                solutionInfo.registration_details.api_details.filter(apiDetails => apiDetails.id === apiProvider.id);
            api.push({
                api: apiProvider.id,
                apiType: apiProvider.apiType,
                requested_status: "",
                apiDisplayName: apiProvider.displayName,
                apiProviderId: apiProvider.id,
                apiProviderName:apiProvider.name,
                isRequired:true,
                customConsentForm:isCustomConesentApi ? custom_consent.customConsentForm : null,
                asyncIntegrationId: registrationDetailsFromSolutionInfo.length && registrationDetailsFromSolutionInfo[0].asyncIntegrationId,
                documentLink:apiProvider.addendumDoc,
                signedTermsAndConditions:consentData ? consentData.signedTermsAndConditions : null
            });
        })
        for (let selectedLocation of selectedLocationsWithCMFNumber) {
            if (consentInfo[selectedLocation.entityId]) {
                let isApiNotConsented = false;
                if (
                    consentInfo[selectedLocation.entityId].addendumsAccepted
                ) {
                    apisToReview && apisToReview.forEach(item => {
                        if (!consentInfo[selectedLocation.entityId].addendumsAccepted.find(addendum => addendum.apiProviderId === item.id)) {
                            isApiNotConsented = true
                        }
                    })
                }
                if (isApiNotConsented) {
                    entityList.push({organizationId: selectedLocation.entityId, cmfNumber: selectedLocation.cmfNumber});
                }
            }
        }

        const entityArray = createChunkArray(entityList);

        const promises = [];

        for(var entities of entityArray) {
            const payload = {
                firstName: firstName,
                lastName: lastName,
                email: userEmail,
                businessTitle: role,
                name: `${firstName} ${lastName}`,
                selectedPlanId: solutionInfo.activateOnly !== false ? "" : planId,
                listingVersion: listingVersion,
                solutionVersion: version ? version : null,
                status: consentConstant.CONSENT_ACCEPTED,
                consentType: consentConstant.CONSENT_TYPE.API_DATA,
                subscriptionStatus: consentConstant.SUBSCRIPTION_STATUS_COMPLETED,
                consentedSource: consentConstant.CONSENTED_SOURCE,
                dpConsentType: CONNECTION,
                solutionId: solutionId,
                orgs: entities,
                apis: api
            }
            promises.push(dispatch(consentApiTerms({payload, token})));
        }

        await Promise.all(promises);

        setReviewApis([]);
        setDialogLoder(false)
        setselectedConnectionDetail(null)

        sendAmplitudeData(AMPLITUDE_EVENTS.ACCEPTED_API_TERMS, {
          [AMPLITUDE_PROPERTIES.APP_NAME]: solutionInfo?.overview?.name,
          [AMPLITUDE_PROPERTIES.APP_ID]: solutionInfo?.id,
          [AMPLITUDE_PROPERTIES.LOCATION_COUNT]:
            selectedLocationsWithCMFNumber?.length,
          [AMPLITUDE_PROPERTIES.LOCATIONS]: selectedLocationsWithCMFNumber?.map(
            (loc) => ({
              [AMPLITUDE_PROPERTIES.ORG_ID]: loc?.entityId,
              [AMPLITUDE_PROPERTIES.ORG_NAME]: loc?.location,
              [AMPLITUDE_PROPERTIES.ORG_CMF]: loc?.cmfNumber,
            })
          ),
          [AMPLITUDE_PROPERTIES.APIS]: apisToReview?.map((apiProvider) => ({
            [AMPLITUDE_PROPERTIES.API_ID]: apiProvider?.id,
            [AMPLITUDE_PROPERTIES.API_NAME]: apiProvider?.name,
          })),
        });
    }

    useEffect(() => {
        if(isCreateApiTermsConsentErrored) {
            setShowToast(true);
        }
        else {
            setShowToast(false);
        }
    }, [isCreateApiTermsConsentErrored]);

    return(
      apisRequiredConsent
      ?
      <div className="addendums-container">
        <div className="addendums-header">
          <div className="addendums-header-title">
            Data integration agreements
          </div>
          <div className="addendums-header-description">
            API's used in this app need permission to access your dealership's
            data.
          </div>
        </div>
        <div className="addendums-list-container">
          {isApiProvidersPending ||
          isApiProviderSelectedByAppPublisherPending ? (
            <Loader style={LOADER_STYLE} />
          ) : (
            <div>
                <div id = 'custom-consent-apis'>
                {
                    customConsentApis && customConsentApis.length
                    ? <ClubbedApis
                        apis = {customConsentApis}
                        isCustomConesentApi = {true}
                        consentDetails = {consentDetails}
                        onReviewTerms = {onReviewTerms}
                        isDataRightsAccepted = {isDataRightsAccepted}
                        doesAppRequireDataRights = {doesAppRequireDataRights}
                        addendumsAccepted = {addendumsAccepted}
                        loadingStatus={loadingStatus}
                        customConsentFormSignedS3Url = {customConsentFormSignedS3Url}
                        consentInfo = {consentInfo}
                    />
                    : null
                }
                </div>
                {customConsentApis.length && (addendumApis.length || noAddendumApis.length) ? <Divider/> : null }
                <div id = 'no-addendum-apis'>
                {
                    noAddendumApis && noAddendumApis
                    ? <ClubbedApis
                        apis = {noAddendumApis}
                        isNoAddendum = {true}
                        consentDetails = {consentDetails}
                        onReviewTerms = {onReviewTerms}
                        isDataRightsAccepted = {isDataRightsAccepted}
                        doesAppRequireDataRights = {doesAppRequireDataRights}
                        addendumsAccepted = {addendumsAccepted}
                        loadingStatus={loadingStatus}
                        consentInfo = {consentInfo}
                    />
                    : null
                }
                </div>
                {noAddendumApis.length && addendumApis.length ? <Divider/> : null }
                <div id = 'addendum-apis'>
                {
                    addendumApis && addendumApis.length
                    ?  addendumApis.map (api => (
                        <ClubbedApis
                            apis = {[api]}
                            consentDetails = {consentDetails}
                            onReviewTerms = {onReviewTerms}
                            isDataRightsAccepted = {isDataRightsAccepted}
                            doesAppRequireDataRights = {doesAppRequireDataRights}
                            addendumsAccepted = {addendumsAccepted}
                            loadingStatus={loadingStatus}
                            consentInfo = {consentInfo}
                        />
                    ))
                    : null
                }
                </div>
            </div>
          )}
        </div>
        {openConsentDialog && (
          <ConsentDialog
            type={'api'}
            open={true}
            title={selectedConnectionDetail.displayName}
            termType={consentConstant.TERM_TYPE.API_TERMS}
            docUrl={isCustomConesentApi ?  customConsentFormSignedS3Url : selectedConnectionDetail.addendumDoc}
            provider={
              selectedConnectionDetail
                ? selectedConnectionDetail
                : {}
            }
            onAccept={saveApiConsent}
            onClose={() => {
                setopenConsentDialog(false);
                setIsCustomConsentApi(false);
                setselectedConnectionDetail(null);
            }}
            userInfo={{
              firstName: userInfo.decodedToken && userInfo.decodedToken.firstName,
              lastName: userInfo.decodedToken && userInfo.decodedToken.lastName
            }}
            email={userInfo && userInfo.userEmail}
            token={token}
            oneClickConsentOnly={isCustomConesentApi}
          />
        )}
        {
            dialogLoader && (
            <Overlay
              active={true}
              hideHeader={true}
              hideFirstButton={true}
              hideSecondButton={true}
              children={<div className="addendum-loader">
                <Loader
                label = "Consenting Data Integration Agreement..."
                style={{ stroke: '#006CFA' }}
                />
              </div>}
              hideCloseButton={true}
            />
            )
        }
        {
            showToast &&
                <Notification
                    content='Failed to accept terms, please try again later'
                    variant='negative'
                    onDismiss={() => {
                        setShowToast(false);
                    }}
                />
        }
      </div>
      : null
    )
}

export default Addendum;
